const RejectionIntelligenceTable = ({ data }) => {
  const total = data.reduce((sum, row) => sum + row.count, 0);

  return (
    <div style={{ width: "100%", overflowX: "auto"  , backgroundColor: "#fff", border: "1px solid #00000026", borderRadius: "10px" , padding:'0px'  }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "clamp(13px, 1vw, 15px)",
        }}
      >
        <style>{`
          @media (min-width: 1800px) {
            .rejection-table td,
            .rejection-table th {
              font-size: 17px !important;
            }
          }
          @media (min-width: 2400px) {
            .rejection-table td,
            .rejection-table th {
              font-size: 20px !important;
            }
          }
        `}</style>

        <thead>
          <tr style={{ background: "#f9fafb" }}>
            {["#", "Rejection Reason", "Count", "Percentage", "Share"].map(
              (h) => (
                <th
                  key={h}
                  style={{
                    padding: "12px 16px",
                    textAlign: h === "Share" || h === "#" ? "center" : "left",
                    fontWeight: 600,
                    color: "#374151",
                    borderBottom: "1.5px solid #e5e7eb",
                    whiteSpace: "nowrap",
                  }}
                >
                  {h}
                </th>
              )
            )}
          </tr>
        </thead>

        <tbody className="rejection-table">
          {data
            .slice()
            .sort((a, b) => b.count - a.count)
            .map((row, idx) => {
              const isEven = idx % 2 === 0;
              const isTop = idx === 0;

              return (
                <tr
                  key={idx}
                  style={{
                    background: isEven ? "#fff" : "#f9fafb",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#E7F2F0")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = isEven
                      ? "#fff"
                      : "#f9fafb")
                  }
                >
                  {/* Index */}
                  <td
                    style={{
                      padding: "12px 16px",
                      textAlign: "center",
                      color: "#9ca3af",
                      fontWeight: 500,
                      borderBottom: "1px solid #f3f4f6",
                      width: "48px",
                    }}
                  >
                    {idx + 1}
                  </td>

                  {/* Reason */}
                  <td
                    style={{
                      padding: "12px 16px",
                      color: "#111827",
                      borderBottom: "1px solid #f3f4f6",
                      fontWeight: isTop ? 600 : 400,
                    }}
                  >
                    {row.loanRejectReason}
                  </td>

                  {/* Count */}
                  <td
                    style={{
                      padding: "12px 16px",
                      color: "#374151",
                      fontWeight: 600,
                      borderBottom: "1px solid #f3f4f6",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.count.toLocaleString()}
                  </td>

                  {/* Percentage */}
                  <td
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #f3f4f6",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 10px",
                        borderRadius: "999px",
                        fontSize: "0.82em",
                        fontWeight: 600,
                        background:
                          row.percentage >= 20
                            ? "#fef3c7"
                            : row.percentage >= 5
                            ? "#E7F2F0"
                            : "#f3f4f6",
                        color:
                          row.percentage >= 20
                            ? "#92400e"
                            : row.percentage >= 5
                            ? "#249578"
                            : "#6b7280",
                      }}
                    >
                      {row.percentage.toFixed(2)}%
                    </span>
                  </td>

                  {/* Bar */}
                  <td
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #f3f4f6",
                      minWidth: "120px",
                      width: "180px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          height: "8px",
                          background: "#e5e7eb",
                          borderRadius: "999px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: `${row.percentage}%`,
                            height: "100%",
                            borderRadius: "999px",
                            background:
                              row.percentage >= 20
                                ? "#f59e0b"
                                : row.percentage >= 5
                                ? "#249578"
                                : "#9ca3af",
                            transition: "width 0.4s ease",
                          }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>

        {/* Footer total */}
        <tfoot>
          <tr style={{ background: "#f3f4f6" }}>
            <td
              colSpan={2}
              style={{
                padding: "12px 16px",
                fontWeight: 700,
                color: "#111827",
                borderTop: "1.5px solid #e5e7eb",
              }}
            >
              Total
            </td>
            <td
              style={{
                padding: "12px 16px",
                fontWeight: 700,
                color: "#249578",
                borderTop: "1.5px solid #e5e7eb",
              }}
            >
              {total.toLocaleString()}
            </td>
            <td
              style={{
                padding: "12px 16px",
                fontWeight: 700,
                color: "#249578",
                borderTop: "1.5px solid #e5e7eb",
              }}
            >
              100%
            </td>
            <td style={{ borderTop: "1.5px solid #e5e7eb" }} />
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default RejectionIntelligenceTable;